module.exports = __webpack_public_path__ + "img/flag.230f7c4.png";